import { useEffect, useState } from 'react';
import { isDefined, userIdFromAddress, } from '@towns-protocol/sdk';
import { check } from '@towns-protocol/dlog';
export function useBlockedUsers(casablancaClient) {
    const [blockedUserIds, setBlockedUserIds] = useState(new Set());
    useEffect(() => {
        if (!casablancaClient || !casablancaClient.userId) {
            return;
        }
        const initBlockedUsers = (stream) => {
            const userSettingsContent = stream.view.userSettingsContent;
            const newBlockedUserIds = new Set();
            Object.keys(userSettingsContent.userBlocks).forEach((key) => {
                if (userSettingsContent.isUserBlocked(key)) {
                    newBlockedUserIds.add(key);
                }
            });
            setBlockedUserIds(newBlockedUserIds);
        };
        const onStreamInitialized = (streamId) => {
            if (streamId !== casablancaClient.userSettingsStreamId) {
                return;
            }
            const stream = casablancaClient.stream(casablancaClient.userSettingsStreamId);
            check(isDefined(stream), 'stream must be defined');
            if (stream && stream.view.isInitialized) {
                initBlockedUsers(stream);
            }
        };
        const onUserBlockUpdated = (userBlock) => {
            setBlockedUserIds((prevBlockedUserIds) => {
                const newBlockedUserIds = new Set(prevBlockedUserIds);
                const userId = userIdFromAddress(userBlock.userId);
                if (userBlock.isBlocked) {
                    newBlockedUserIds.add(userId);
                }
                else {
                    newBlockedUserIds.delete(userId);
                }
                return newBlockedUserIds;
            });
        };
        if (casablancaClient.userSettingsStreamId) {
            const stream = casablancaClient.stream(casablancaClient.userSettingsStreamId);
            if (stream && stream.view.isInitialized) {
                initBlockedUsers(stream);
            }
        }
        casablancaClient.on('userBlockUpdated', onUserBlockUpdated);
        casablancaClient.on('streamInitialized', onStreamInitialized);
        return () => {
            casablancaClient.off('userBlockUpdated', onUserBlockUpdated);
            casablancaClient.off('streamInitialized', onStreamInitialized);
        };
    }, [casablancaClient]);
    useEffect(() => {
        console.log(`useBlockedUsers blockedUserIds`, { blockedUserIds });
    }, [blockedUserIds]);
    return blockedUserIds;
}
//# sourceMappingURL=use-blocked-users.js.map